import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./App.js"
import "./components/components.css"
import { BrowserRouter } from 'react-router-dom';
import AuthProvider from './contexts/AuthContext.jsx';

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render (
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)

